//自定义axios
export default {
  install: async function(Vue, configPath) {
    //定义全局参数
    Vue.prototype.SystemParameters = "";
    Vue.prototype.SystemTitle = "";
    Vue.prototype.SystemName = "";
    Vue.prototype.MaintenanceUnitName = "";
    Vue.prototype.LABELPOSTION = "top";
    Vue.prototype.PAGESIZE = 8;
    Vue.prototype.ISMOBILE = true;

    //系统基本访问地址
    Vue.prototype.pstApi = {
      //单位成员查询
      async getEmps(searchName, pageIndex = 1, pageSize = 10) {
        var data = {
          Platform: true,
          Name: searchName,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/emp/list",
          params: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      getUserData() {
        var store = window.sessionStorage.getItem("UserData");
        var userdata = JSON.parse(store);
        return userdata;
      },
      getToken() {
        return window.sessionStorage.getItem("token");
      },
      getUserRoles() {
        var store = window.sessionStorage.getItem("UserData");
        var userdata = JSON.parse(store);
        //console.log(userdata)
        if (userdata) {
          return userdata.hasRoles;
        }
        return null;
      },
      //舆情类别
      pstTypes: [
        {
          title: "所有工单类型",
          value: -1,
        },
        {
          title: "网络留言",
          value: 0,
        },
        {
          title: "负面舆情",
          value: 1,
        },
      ],
      getPstTypeName(pstTypeValue) {
        let title = "";
        for (var i = 0; i < Vue.prototype.pstApi.pstTypes.length; i++) {
          let item = Vue.prototype.pstApi.pstTypes[i];
          if (item.value == pstTypeValue) {
            title = item.title;
            break;
          }
        }
        return title;
      },
      pstorders: [
        {
          title: "待审查",
          value: 1,
        },
        {
          title: "待转办",
          value: 2,
        },
        {
          title: "待办理",
          value: 3,
        },
        {
          title: "待审核",
          value: 4,
        },
        {
          title: "无佐证",
          value: 5,
        },
        {
          title: "已办结",
          value: 6,
        },
        {
          title: "已收藏",
          value: 7,
        },
      ],
      //状态类型
      categorys: [
        {
          title: "所有工单状态",
          nodeTitle: "所有工单状态",
          transferTitle: "所有工单状态",
          timeTitle: "",
          value: -10,
          icon: "el-icon-position",
        },
        {
          title: "工单提交",
          nodeTitle: "提交信息",
          transferTitle: "待审查",
          timeTitle: "上报时间",
          value: -2,
          icon: "el-icon-position",
        },

        {
          title: "工单审查",
          nodeTitle: "工单审查",
          transferTitle: "待转办",
          timeTitle: "审查时间",
          value: 0,
          icon: "el-icon-position",
        },
        {
          title: "工单转办",
          nodeTitle: "工单转办",
          transferTitle: "待办理",
          timeTitle: "转办时间",
          value: 1,
          icon: "el-icon-position",
        },
        {
          title: "答复信息",
          nodeTitle: "工单办理",
          transferTitle: "答复待审",
          timeTitle: "办理时间",
          value: 2,
          icon: "el-icon-chat-line-square",
        },
        {
          title: "重新转办",
          nodeTitle: "重新转办",
          transferTitle: "重办待转",
          timeTitle: "要求转办时间",
          value: 3,
          icon: "el-icon-chat-line-square",
        },
        {
          title: "答复通过",
          nodeTitle: "答复审核",
          transferTitle: "已审缺佐证",
          timeTitle: "答复审核时间",
          value: 4,
          icon: "el-icon-s-check",
        },
        {
          title: "补充佐证",
          nodeTitle: "补充佐证",
          transferTitle: "待补佐证",
          timeTitle: "",
          value: 5,
          icon: "el-icon-picture",
        },
        {
          title: "存档备查",
          nodeTitle: "存档收藏",
          transferTitle: "已经存档",
          timeTitle: "存档时间",
          value: -1,
          icon: "el-icon-position",
        },
        {
          title: "已经办结",
          nodeTitle: "已经办结",
          transferTitle: "已经办结",
          timeTitle: "",
          value: 6,
          icon: "el-icon-chat-dot-round",
        },
      ],
      getTimeTitle(status) {
        let title = "";
        for (var i = 0; i < Vue.prototype.pstApi.categorys.length; i++) {
          let item = Vue.prototype.pstApi.categorys[i];
          if (item.value == status) {
            title = item.timeTitle;
            break;
          }
        }
        return title;
      },
      getStatusTransferTitle(status) {
        let title = "";
        for (var i = 0; i < Vue.prototype.pstApi.categorys.length; i++) {
          let item = Vue.prototype.pstApi.categorys[i];
          if (item.value == status) {
            title = item.transferTitle;
            break;
          }
        }
        return title;
      },
      getStatusTitle(categoryValue) {
        let title = "";
        for (var i = 0; i < Vue.prototype.pstApi.categorys.length; i++) {
          let item = Vue.prototype.pstApi.categorys[i];
          if (item.value == categoryValue) {
            title = item.title;
            break;
          }
        }
        return title;
      },
      getNodeTitle(categoryValue) {
        let title = "";
        for (var i = 0; i < Vue.prototype.pstApi.categorys.length; i++) {
          let item = Vue.prototype.pstApi.categorys[i];
          if (item.value == categoryValue) {
            title = item.nodeTitle;
            break;
          }
        }
        return title;
      },
      getStatusIcon(categoryValue) {
        let icon = "";
        for (var i = 0; i < Vue.prototype.pstApi.categorys.length; i++) {
          let item = Vue.prototype.pstApi.categorys[i];
          if (item.value == categoryValue) {
            icon = item.icon;
            break;
          }
        }
        return icon;
      },
      setWindowTitle(title = "") {
        if (title.length > 0) {
          document.title = Vue.prototype.SystemName + "-" + title;
        } else {
          document.title = Vue.prototype.SystemName;
        }
      },
      setWebsiteParameters(parameters) {
        Vue.prototype.SystemParameters = parameters;
        Vue.prototype.SystemTitle = parameters.systemName;
        Vue.prototype.SystemName = parameters.systemName;
        Vue.prototype.MaintenanceUnitName = parameters.maintenanceUnitName;
        if (Vue.prototype._isMobile() != null) {
          Vue.prototype.SystemName = parameters.systemMiniName;
          Vue.prototype.MaintenanceUnitName =
            parameters.maintenanceUnitMiniName;
        }
      },
      //DeepSeek根据文字内容审稿
      async callDeepSeek_Text(message) {
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/ai/text",
          timeout: 300000,
          data: {
            Text: message,
            Instruction: "帮我审核这些内容",
          },
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //DeepSeek根据用户要求搜索舆情文件进行分析
      async callDeepSeek_File(
        dateRangeValues,
        unitIds,
        pstTypes,
        categories,
        domains,
        instruction,
        isPstContent
      ) {
        const data = {
          DateRangeValues: dateRangeValues,
          TransferUnitIds: unitIds,
          TypeValues: pstTypes,
          OrderValues: categories,
          DomainValues: domains,
          Instruction: instruction, //"帮我生成一篇舆情报告",
          IsPstContent: isPstContent,
        };
        // console.log(data);
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/ai/file", //super/ai/file
          timeout: 300000,
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //====================== admin 网站基本信息 =============================
      //读取系统网站信息
      async getWebsiteParameters() {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/parameter",
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //读取系统网站全部信息
      async getWebsiteAllParameters() {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/allParameter",
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //更新系统网站信息 V
      async updateWebsiteParameters(
        systemName,
        systemMiniName,
        maintenanceUnitName,
        maintenanceUnitMiniName,
        transferHours,
        domains,
        userName,
        phone,
        email
      ) {
        var data = {
          SystemName: systemName,
          SystemMiniName: systemMiniName,
          MaintenanceUnitName: maintenanceUnitName,
          MaintenanceUnitMiniName: maintenanceUnitMiniName,
          TransferHours: transferHours,
          Domains: domains,
          UserName: userName,
          Phone: phone,
          Email: email,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "put",
          url: "/parameter",
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //====================== 角色管理 =======================
      //读取用户角色信息 VgetEmploy
      async getRoles() {
        //console.log("getRoles")
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/user/roles",
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //读取管理员列表 V
      async getManagers(queryString, pageIndex = 1, pageSize = 10) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/role/list",
          params: {
            QueryString: queryString,
            PageNumber: pageIndex,
            PageSize: pageSize,
          },
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //读取管理员角色 V
      async getManager(userId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/role/get/" + userId,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //创建管理员角色 V
      async createManager(userId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/role/create/" + userId,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //更新管理员角色 V
      async updateManager(userId, roles) {
        var data = {
          Roles: roles,
        };
        var res = await Vue.prototype.WXPstAxios({
          method: "put",
          url: "/role/update/" + userId,
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //删除管理员角色 V
      async deleteManager(userId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "delete",
          url: "/role/delete/" + userId,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //==========================  Super 操作 ---- 节点操作  ==========================
      //获取留言列表 V
      async getPstList(
        unitId = "00000000-0000-0000-0000-000000000000",
        pstType = -1,
        statusSelects,
        queryString = "",
        pageNumber = 1,
        pageSize = 10,
        isSubmit = -1
      ) {
        let data = {
          UnitId: unitId,
          PstType: pstType,
          QueryStatus: statusSelects,
          IsSubmit: isSubmit,
          QueryString: queryString,
          PageNumber: pageNumber,
          PageSize: pageSize,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/pst/list",
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //删除舆情记录 V
      async deletePst(pstId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "delete",
          url: "/super/pst/delete/" + pstId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //导入舆情excel列表
      async pstImport(formData) {
        //pst/import
        var res = await Vue.prototype.WXPstAxios({
          headers: {
            "Content-Type": "multipart/form-data",
          },
          method: "post",
          url: "/super/pst/import",
          data: formData,
          // responseType: "blob", //二进制流
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //导出平台工单列表
      async exportPstList(
        dateRangeValues,
        unitIds,
        pstTypes,
        categorys,
        domains
      ) {
        let data = {
          DateRangeValues: dateRangeValues,
          TransferUnitIds: unitIds,
          TypeValues: pstTypes,
          OrderValues: categorys,
          DomainValues: domains,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/export/pstlist",
          data: data,
          responseType: "blob",
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //领域设置
      async updatePstDomain(pstId, domain) {
        //pst/import
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/pst/domain/" + pstId,
          data: {
            Domain: domain,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取新舆情列表 V
      async getNewPstList(queryString = "", pageNumber = 1, pageSize = 10) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/super/transfer/list",
          params: {
            Status: 0,
            IsSubmit: 1,
            QueryString: queryString,
            PageNumber: pageNumber,
            PageSize: pageSize,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取已提交的负面舆情列表 V
      async getNegativeSubmits(
        queryString = "",
        pageNumber = 1,
        pageSize = 10
      ) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/super/negative/list",
          params: {
            //Category: -2,
            QueryString: queryString,
            PageNumber: pageNumber,
            PageSize: pageSize,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取舆情详细信息 V
      async getPstInfo(pstId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/super/pst/get/" + pstId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取已提交的负面舆情信息 V
      async getNegativeSubmit(pstId) {
        //console.log(pstId)
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/super/negative/get/" + pstId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //负面舆情审核：撤销重报、收藏备查、通过转为新舆情 V
      async negativeAudit(pstId, message, submitType, status, transferUnId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/node/negativeaudit/" + pstId,
          data: {
            Message: message,
            SubmitType: submitType, //1-提交 0-保存
            Status: status,
            TransferUnId: transferUnId,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //舆情转办处理 V
      async newPstTransfer(pstId, unitId, mssage, submitType) {
        if (unitId == "") {
          unitId = "00000000-0000-0000-0000-000000000000";
        }
        var data = {
          SubmitType: submitType,
          TransferUnitId: unitId,
          Message: mssage,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/node/transfer/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //舆情答复审核处理 V
      async replyPstAudit(pstId, mssage, submitType) {
        var data = {
          SubmitType: submitType,
          Message: mssage,
        };
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/node/audit/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //========================== Manager 操作 ---- 舆情操作================================
      //--创建负面舆情 V
      async createNegative(
        title,
        pstUrl,
        name,
        postingTime,
        pstSource,
        pstContent,
        category,
        pstType
      ) {
        let data = {
          PstType: pstType,
          Title: title,
          PstUrl: pstUrl,
          Name: name,
          PostingTime: postingTime,
          PstSource: pstSource,
          PstContent: pstContent,
          Status: category,
        };
        // console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/manager/negative/create",
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //更新负面舆情节点信息 V
      async updateManagerNodeMessage(pstId, message, isSucces) {
        let data = {
          NodeMessage: message,
          IsSucces: isSucces,
        };
        var res = await Vue.prototype.WXPstAxios({
          method: "put",
          url: "/manager/node/update/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取单位办理舆情详细信息 V
      async getHandlePstInfo(pstId) {
        //console.log(pstId)
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/manager/pst/get/" + pstId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //更新负面舆情, category V
      async updateNegative(
        pstId,
        title,
        pstUrl,
        name,
        postingTime,
        pstSource,
        pstContent,
        pstType
      ) {
        let data = {
          Title: title,
          PstUrl: pstUrl,
          Name: name,
          PostingTime: postingTime,
          PstSource: pstSource,
          PstContent: pstContent,
          //SectionId:"",
          //Status: category,
          PstType: pstType,
        };
        // console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "put",
          url: "/manager/negative/update/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取本单位负面舆情列表 V
      async getNegativeList(
        category,
        queryString = "",
        pageNumber = 1,
        pageSize = 10
      ) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/manager/negative/list",
          params: {
            Status: category,
            QueryString: queryString,
            PageNumber: pageNumber,
            PageSize: pageSize,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //删除负面舆情记录 V
      async deleteNegative(pstId) {
        var res = await Vue.prototype.WXPstAxios({
          method: "delete",
          url: "/manager/negative/delete/" + pstId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取本单位舆情回复列表 V
      async getReplyList(
        pstType,
        queryString = "",
        pageNumber = 1,
        pageSize = 10
      ) {
        var data = {
          PstType: pstType,
          QueryString: queryString,
          PageNumber: pageNumber,
          PageSize: pageSize,
        };

        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/manager/transfer/list",
          params: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //舆情答复办理
      async pstReply(
        pstId,
        submitType,
        selectType,
        message,
        extension,
        extensionMessage
      ) {
        var status = 2;
        if (selectType == 3) {
          status = 3;
        }
        let data = {
          SubmitType: submitType,
          Status: status,
          Message: message,
          Extension: parseInt(extension),
          ExtensionMessage: extensionMessage,
        };
        //console.log(data)
        //return;
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/manager/node/reply/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //答复延期审核
      async pstReplyExtensionAudit(pstId, extension) {
        let data = {
          Extension: extension,
        };
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/super/node/extension_audit/" + pstId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取本单位舆情回复待补佐证列表 V
      async getEvidentcePstList(
        pstType,
        queryString = "",
        pageNumber = 1,
        pageSize = 10
      ) {
        var res = await Vue.prototype.WXPstAxios({
          method: "get",
          url: "/manager/evident/list",
          params: {
            PstType: pstType,
            QueryString: queryString,
            PageNumber: pageNumber,
            PageSize: pageSize,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取留言列表 V
      async getUnitPstList(
        pstType = -1,
        statusSelects,
        queryString = "",
        pageNumber = 1,
        pageSize = 10,
        isSubmit = -1
      ) {
        let data = {
          PstType: pstType,
          QueryStatus: statusSelects,
          IsSubmit: isSubmit,
          QueryString: queryString,
          PageNumber: pageNumber,
          PageSize: pageSize,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/manager/pst/list",
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //导出单位工单列表
      async exportUnitPstList(dateRangeValues, pstTypes, categorys) {
        let data = {
          DateRangeValues: dateRangeValues,
          TypeValues: pstTypes,
          OrderValues: categorys,
        };
        //console.log(data)
        var res = await Vue.prototype.WXPstAxios({
          method: "post",
          url: "/manager/export/pstlist",
          data: data,
          responseType: "blob",
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
    };
    Vue.prototype.appApi = Vue.prototype.pstApi;
  },
};
